import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ColorSelectorItemComponent } from '../../../basic/color/color-selector-x/color-selector-item/color-selector-item.component';
import { SelectGroupComponent, SelectGroupMode } from '../../../basic/select-group/select-group.component';

@Component({
  selector: 'app-portrait-select',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, ColorSelectorItemComponent, SelectGroupComponent],
  templateUrl: './portrait-select.component.html',
  styleUrl: './portrait-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortraitSelectComponent {
  SelectGroupMode = SelectGroupMode;

  @Input() portraitUrl?: string;
  @Output() portraitUrlChange = new EventEmitter<string>();

  selectableList: {
    isSelected: boolean;
    portraitUrl: string;
  }[] = [];

  constructor() {
    for (let i = 1; i <= 20; i++) {
      const formattedNumber = i.toString().padStart(2, '0');
      this.selectableList.push({
        isSelected: false,
        portraitUrl: `/assets/images/ai-profile/portrait_${formattedNumber}.png`,
      });
    }
  }

  ngOnInit() {
    const item = this.selectableList.find((c) => c.portraitUrl === this.portraitUrl);

    if (item) {
      item.isSelected = true;
    }
  }

  onItemChange(item: any) {
    this.portraitUrlChange.emit(item.portraitUrl);
  }
}
